import { CalendarUnit } from '@principle-theorem/principle-core/interfaces';

export interface ICalendarParams {
  calendarUnit: CalendarUnit;
  from: string;
  to: string;
}
